import React from "react";
import "./App.css";
import ServiceEndNotice from "./ServiceEndNotice.tsx";

function App() {
  document.oncontextmenu = function () {
    return false;
  };

  return (
    <div className="container">
      <div className="App">
        <main>
          <ServiceEndNotice />
        </main>
      </div>
    </div>
  );
}

export default App;
